import script from "./LaputaResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./LaputaResetPassword.vue?vue&type=style&index=0&id=2fc51d9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc51d9f"]])

export default __exports__